<template>
    <div>

      <div class="table_card">
        <div class="table_card__head">
          <p class="table_card__head--title">Búsqueda de usuario</p>
        </div>
        <div class="table_card__body">
          <v-layout row wrap>
            <v-flex xs6 row>
              <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
                <input
                  v-model="searching_data"
                  placeholder="Ingrese el documento del usuario o email"
                  required
                  class="input_solid"
                  style="width: 98% !important"
                >
                <img
                  src="@/assets/img/icons/search-icon.svg"
                  class="button_search"
                  style="margin-left: -55px"
                >
              </v-form>
            </v-flex>
            <v-flex xs6 class="pl-2">
              <button
                type="button"
                class="faccess_button"
                @click="getUserData()"
                :disabled="!valid || searching_data == ''"
              >
                Consultar
              </button>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div class="table_card mt-4" v-if="user_finded">
        <div class="table_card__head">
          <p class="table_card__head--title">
            Información de usuario
          </p>
        </div>
        <div class="table_card__body">
          <v-layout row wrap>
            <v-flex xs12 row>
              <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap style="background-color: #fff; padding: 0px;">


                <v-flex xs6 style="padding: 8px">
                  <span class="table_card__info--label">Foto</span>
                  <div class="trainers__form--photo_container">
                    <label
                      for="trainerPhoto"
                      class="faccess_button buttom_shadow px-5">Examinar</label>
                    <input
                      id="trainerPhoto"
                      type="file"
                      accept="image/x-png,image/gif,image/jpeg"
                      @change="onFileChange"
                      name="photo">

                  </div>
                </v-flex>

                <v-flex xs6 style="padding: 8px; " class="classes__image_container mb-4">
                  <div
                    class="data_card__import_img"
                    :style="{backgroundImage: 'url('+ user_url_photo +')'}">
                  </div>

                  <div
                    title="Sincronizar en dispositivos fisicos"
                    class="edit_user_form__sync_button"
                    @click="syncUserOnDevices()"
                    v-if="user_facial_devices && user.user_info_attributes.photo && !user.photo">
                    Sincronizar
                    <span class="material-icons ml-2" style="font-size: 1.2rem;">sync</span>
                  </div>
                </v-flex>

                <v-flex xs6 style="padding: 8px">
                  <v-text-field
                    label="Número de documento:"
                    v-model="user.rut"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex
                  xs6
                  style="padding: 15px 8px">
                  <v-select
                    item-text="name"
                    item-value="id"
                    v-model="user.document_type"
                    :items="document_types"
                    label="Seleccionar tipo de documento:">
                  </v-select>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Nombre:"
                    v-model="user.user_info_attributes.name"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Apellido:"
                    v-model="user.user_info_attributes.last_name"
                    required>
                  </v-text-field>
                </v-flex>
                <!-- <label>Teléfono:</label> -->
                <v-flex
                  style="padding: 8px; display: flex; height: 60px;">
                  <vue-country-code
                    style="box-shadow: none;"
                    :default-country="user.country_phone_name"
                    :enabled-country-code="true"
                    @onSelect="selectCountry"
                    @on-select="selectCountry">
                  </vue-country-code>
                  <v-text-field
                    style="padding-left: 10px;"
                    type="tel"
                    label="Teléfono"
                    v-model="user.mobile"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    label="Correo electrónico:"
                    v-model="user.email"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 0px 8px">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="user.user_info_attributes.birthday"
                        label="Fecha de nacimiento:"
                        append-icon="today"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="user.user_info_attributes.birthday"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs6 style="padding: 0px 8px">
                  <label style="color: gray; font-size: 12px;">Género:</label>
                  <v-radio-group
                    v-model="user.user_info_attributes.gender"
                    row>
                    <v-radio
                      label="Mujer"
                      value="Femenino"
                      color="#1476FB"
                    ></v-radio>
                    <v-radio
                      label="Hombre"
                      value="Masculino"
                      color="#1476FB"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    type="password"
                    label="Contraseña:"
                    v-model="user.password"
                    :rules="[rules.length]"
                    :change="validatePasswords()"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px">
                  <v-text-field
                    type="password"
                    label="Confirmación Contraseña:"
                    v-model="user.password_confirmation"
                    :change="validatePasswords()"
                    :rules="[rules.required, rules.length, rules.match]"
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 15px 8px">
                  <v-select
                    item-text="name"
                    item-value="id"
                    v-model="user.user_info_attributes.user_category_id"
                    :items="user_categories"
                    label="Seleccionar plan de usuario:"
                  ></v-select>
                </v-flex>

                <!--v-if="getCompany().payments.admin_payments"-->
                <v-flex
                  xs6
                  style="padding: 15px 8px">

                  <v-text-field
                    label="Inmueble Asignado:"
                    v-model="user.user_info_attributes.sublocation_name"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="user.user_info_attributes.access_state == 'ACTIVO'">
                  <v-text-field
                    label="Fecha inicio del plan:"
                    v-model="user.user_info_attributes.plan_from"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="user.user_info_attributes.access_state == 'ACTIVO'">
                  <v-text-field
                    label="Fecha limite del plan:"
                    v-model="user.user_info_attributes.plan_until"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex
                  xs6
                  style="padding: 8px"
                  v-if="user.user_info_attributes.access_state == 'DENEGADO'">
                  <v-text-field
                    label="Estado del plan:"
                    v-model="user.user_info_attributes.access_state"
                    disabled
                    required>
                  </v-text-field>
                </v-flex>

                <v-flex xs6 style="padding: 0px 8px" v-if="getCompany().max_time_exceeded_blocking">
                  <label style="color: gray; font-size: 12px;">Salida de usuario:</label>
                  <v-radio-group
                    v-model="user.blocked"
                    row>
                    <v-radio
                      label="Bloqueado"
                      :value="true"
                      color="#1476FB"
                    ></v-radio>
                    <v-radio
                      label="Desbloqueado"
                      :value="false"
                      color="#1476FB"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

              </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </div>
        <div class="table_card__footer" v-if="user_finded">
          <button
            type="button"
            @click="saveUserInfo()"
            :disabled="!valid_password"
            class="faccess_button"
          >
            Guardar información
          </button>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data(){
      return{
        searching_data: '',
        menu: false,
        searching_rut: '',
        locations: [],
        // sublocations: [],
        user_categories: [],
        document_types: [
          {id: "CD", name: "Carnet Diplomatico"},
          {id: "CC", name: "Cedula de Ciudadania"},
          {id: "CE", name: "Cedula de Extranjeria"},
          {id: "CA", name: "Certificado Cabildo"},
          {id: "IS", name: "Identificación dada por la Secretaria de Educación"},
          {id: "NI", name: "Nit"},
          {id: "PA", name: "Pasaporte"},
          {id: "PE", name: "Permiso Especial de Permanencia"},
          {id: "PPT", name: "Permiso de Protección Temporal"},
          {id: "RC", name: "Registro Civil"},
          {id: "SC", name: "Salvoconducto de Permanencia"},
          {id: "TI", name: "Tarjeta de Identidad"},
          {id: "TM", name: "Tarjeta de Movilidad Fronteriza (tmf)"}
        ],
        user: {
          id:'',
          email: '',
          country_phone_code: '',
          country_phone_name: '',
          mobile: '',
          rut: '',
          document_type: '',
          password: '',
          company_id: '',
          password_confirmation: '',
          blocked: '',
          photo:'',
          user_info_attributes:{
            name: '',
            last_name: '',
            gender: '',
            birthday: new Date().toISOString().substr(0, 10),
            location_id: '',
            sublocation_id: '',
            sublocation_name: '',
            user_category_id: '',
            plan_from: '',
            plan_until: '',
            access_state: ''
          }
        },
        rules: {
          required: value => !!value || 'Requerido',
          length: value => value.length > 5 || 'Mínimo 6 caracteres',
          match: value => value === this.user.password || 'Las contraseñas deben coincidir'
        },
        user_finded: false,
        valid: false,
        valid_password: true,
        user_url_photo: '',
        user_url_photo_change: false,
        user_facial_devices: false
      }
  },
  methods:{
    selectCountry({name, iso2, dialCode}){
      console.log(iso2,dialCode)
      this.user.country_phone_code = '+' + dialCode
      this.user.country_phone_name = iso2
    },
    onFileChange (e) {

       var fileInput = document.getElementById('trainerPhoto');
       var filePath = fileInput.value;
       var extension = filePath.replace(/^.*\./, '');

       var fileSize = parseInt(fileInput.files[0].size /1024)
       var allowedExtensionsImg = /(.jpg|.jpeg|)$/i;


       if(extension != "jpg" && extension != "jpeg" ){
          this.updateAlertMessage('Solo se admite el formato jpg o jpeg')
          this.updateIsInAlert(true);
       }else if(fileSize > 200){
          this.updateAlertMessage('El tamaño de la foto no puede ser mayor a 200KB')
          this.updateIsInAlert(true);
       }else{

          var files = e.target.files || e.dataTransfer.files
          if (!files.length) {
            return
          }
          this.user_url_photo = URL.createObjectURL(files[0])

          this.createImage(files[0], ""+e.target.name)

       }

    },
    createImage (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {


        vm.user.photo = reader.result
      }
    },
    validate_data(searching_data){
      let re = /\S+@\S+\.\S+/
      return re.test(searching_data)
    },
    getUserData(){
      var params = this.$route.params;
      this.user.email = ''
      this.user.rut = ''
      if(this.validate_data(this.searching_data)){
        console.log(this.searching_data);
        this.user.email = this.searching_data
      }else{
        console.log(this.searching_data);
        console.log(this.user);
        this.user.rut = this.searching_data
      }
      try {
        this.$http.get('app/users/find_user_by_rut', {
            headers: {
                "X-Device-ID" : this.getDeviceId(),
                "Authorization" : 'Bearer ' + this.getUserToken()
            },
            params:{
              rut: this.user.rut,
              email: this.user.email,
              company_id: this.getCompany().id
            }
        }).then(function(response){
          if(response.body != null){
            console.log('la info del usuario', response.body)
              var data = response.body.user
              var data_user_info = response.body.user_info
              this.user.id = data.id
              this.user.rut = data.rut
              this.user.document_type = data.document_type
              this.user.email = data.email
              this.user.country_phone_code = data.country_phone_code
              this.user.country_phone_name = data.country_phone_name
              this.user.mobile = data.mobile
              this.user.company_id = data.company
              this.user.blocked = data.blocked
              this.user.photo = ""
              this.user.user_info_attributes.name = data_user_info.name
              this.user.user_info_attributes.last_name = data_user_info.last_name
              this.user.user_info_attributes.photo = data_user_info.picture.url != null ? this.getImageServer() + data_user_info.picture.url : null
              this.user_url_photo = data_user_info.picture.url != null ? this.getImageServer() + data_user_info.picture.url : null
              this.user.user_info_attributes.birthday = data_user_info.birthday != null ? new Date(data_user_info.birthday).toISOString().substr(0, 10) : ''
              this.user.user_info_attributes.location_id = data_user_info.location_id != null ? data_user_info.location_id.toString() : ""
              this.user.user_info_attributes.user_category_id = data_user_info.user_category_id != null ? data_user_info.user_category_id : ""
              this.user.user_info_attributes.plan_from = data_user_info.plan_from != null ? this.$moment(data_user_info.plan_from).format("L") : null
              this.user.user_info_attributes.plan_until = data_user_info.plan_until != null ? this.$moment(data_user_info.plan_until).format("L") : null
              this.user.user_info_attributes.access_state = data_user_info.access_state == "GRANTED" ? "ACTIVO" : "DENEGADO"
              this.user_facial_devices = response.body.facial_devices

              if(response.body.user_sublocation !== null){
                this.user.user_info_attributes.sublocation_id = response.body.user_sublocation.id
                this.user.user_info_attributes.sublocation_name =`${response.body.user_sublocation.name}`
              } else {
                this.user.user_info_attributes.sublocation_name = 'No asignado'
              }
              // this.sublocations = response.body.sublocations
              // this.sublocations.unshift({id: null, name: "No asignar"})
              if(data_user_info.gender != null && data_user_info.gender != ""){
                if(data_user_info.gender === "Male" || data_user_info.gender === "Female"){
                  this.user.user_info_attributes.gender = data_user_info.gender === "Male" ? "Masculino" : "Femenino"
                }else{
                  this.user.user_info_attributes.gender = data_user_info.gender
                }
              }
              // this.user.user_info_attributes.access_state = data.user_info.access_state == "GRANTED" ? "Activo" : "Inactivo"
              if (response.body.user_categories.length > 0) {
                this.user_categories = response.body.user_categories
              }
              this.user_finded = true
              console.log("USER <<<<<", this.user)
          }else{
              this.user_finded = false
              this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
              this.updateIsInAlert(true);
          }
        }, function(response){
          // this.updateAlertMessage("No te hemos encontrado en los registros de sportlife", "Lo sentimos")
          this.user.id = ""
          this.user.rut = ""
          this.user.email = ""
          this.user.country_phone_code = ""
          this.user.country_phone_name = ""
          this.user.mobile = ""
          this.user.photo = ""
          this.user.user_info_attributes.name = ""
          this.user.user_info_attributes.last_name = ""
          this.user.user_info_attributes.gender = ""
          this.user.user_info_attributes.birthday = ""
          this.user.user_info_attributes.location_id = ""
          this.user.user_info_attributes.user_category_id = ""
          this.user_facial_devices = false
          this.user_finded = false
          this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
          this.updateIsInAlert(true);
        })
      } catch (e) {
          this.updateAlertMessage(e.message)
          this.updateIsInAlert(true);
      }
    },
    saveUserInfo(){
      if(this.validateMobile()){
        var vm = this;
        var data = vm.user;
        console.log('data a enviar', data)
        try {
          this.$http.post('users/update_client_data_by_counter',{
            data: this.encrypt(data).toString(),
            attributes:this.encrypt(data).toString()
          },
          {
            headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }

          }).then(
            function(response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (response.body && response.status == 201) {
                this.updateAlertMessage(response.body.ans);
                this.updateIsInAlert(true);
                this.user_finded = false
                this.searching_rut = ''
              }
            },
            function(response) {
              if (
                response.body.meta != undefined &&
                response.body.meta != null
              ) {
                if (
                  response.body.meta.authentication_token != undefined &&
                  response.body.meta.authentication_token != null
                ) {
                  this.checkToken(response.body.meta.authentication_token);
                }
              }
              if (response.status === 422) {
                this.updateAlertMessage(response.body.errors[0].details);
                this.updateIsInAlert(true);
              }
            }
          );
        } catch (e) {
          this.updateAlertMessage(e.message);
          this.updateIsInAlert(true);
        }
      } else {
        this.updateAlertMessage("Por favor ingresa un número de teléfono válido");
        this.updateIsInAlert(true);
      }
    },
    validateMobile(){
      return !this.user.mobile.match(/[A-Za-z]+/g)
    },
    validatePasswords(){
      let user = this.user
      if (user.password === '' && user.password_confirmation === '' || (user.password === user.password_confirmation && user.password.length > 5)){
        this.valid_password = true
      }
      else if(user.password != '' && user.password_confirmation === '' || user.password !== user.password_confirmation || user.password.length < 6){
        this.valid_password = false
      }
    },
    syncUserOnDevices(){
      const payload = {
        user_id: this.user.id
      }

      this.$http.post('users/sync_user_on_devices', {
        data: this.encrypt(payload).toString()
      },
      {
        headers: {
          "X-Device-ID" : this.getDeviceId(),
          "Authorization" : 'Bearer ' + this.getUserToken()
        }

      }).then(res => {
        if (res.body && res.status == 200) {
          this.updateAlertMessage(res.body.ans);
          this.updateIsInAlert(true);
        }

      }).catch(e => {
        this.updateAlertMessage(e.body.errors[0].details);
        this.updateIsInAlert(true);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/users/EditUser.vue